import React, { Component } from 'react';
import { Modal, Row, Col, Table} from 'react-bootstrap';
import _ from 'lodash';

export default class ViewClientDetails extends Component {  
    render(){
      const{data} = this.props;
      return(
      <Modal show={true}
      onHide={this.props.closeModal}
      dialogClassName="modal-120w clientrecordxl"
      size='xl'
      aria-labelledby="contained-modal-title-vcenter"
      centered>  
       <Modal.Header closeButton>
            <Modal.Title id="example-custom-modal-styling-title">Client Details</Modal.Title>   
      </Modal.Header>
      <Modal.Body>
      <div>
         <Row>
          <Col>
            <Row><Col md={5}> <h6>Client Name</h6></Col>
            <Col className='colorBlue'>{data.inventoryClientName}</Col></Row>
            <Row><Col md={5}><h6>Client Contact Number</h6></Col>
            <Col className='colorBlue'>{data.mobileNumber}</Col></Row>
            <Row><Col md={5}><h6>Client Email</h6></Col>
            <Col className='colorBlue'>{data.email}</Col></Row>         
          </Col>
        </Row>
      <Row>
        <Col>
      {_.map(data.clientRegions, (obj)=>{
        return(<Row>
          <Col md={5}><h6>Region Name</h6></Col><Col className='colorBlue'>{obj.inventoryRegionName}</Col><br/>
          {_.map(obj.clientCenters, (xot)=> {
          return(
              <Table responsive>
                <thead><th>CENTER</th>
                <th>PROCESS</th>
                <th>LOGO</th>
                <th>CONTACT PERSON<br/> NAME</th>
                <th>CONTACT PERSON<br/> NUMBER</th>
                <th>CONTACT PERSON<br/> EMAIL</th>
                <th>REPORTS & FREQUENCY</th>
                </thead>
                <tbody>
                {(!_.isEmpty(xot.contactDetails)) ? 
                _.map(xot.contactDetails, (gg, i) => {
                return (<tr>
                  { (i=== 0) ?
                  <th className={(i === 0 ) ? 'widthSpecific' : ' widthSpecific noheader'}>{xot.inventoryCenterName}</th> : <td/>}
                  { (i === 0) ?
                  <th className={(i === 0 ) ? 'widthSpecific' : ' widthSpecific noheader'}>{_.map(xot.processes, (tt) =>{
                    return(<span>{tt.inventoryProcessName}<br/></span>) }) }</th> : <td/>}
                  { (i === 0) ?
                  <th className={(i === 0 ) ? 'widthSpecific' : ' widthSpecific noheader'}>{!_.isNull(xot.logo) ? <img src={xot.logo} width='50px' height='30px' alt='clientlogo'/> : null}
                    {!_.isNull(xot.logoName) ? xot.logoName : null }</th> : <td/>}
                <td>{gg.personName}</td>
                <td>{gg.mobileNumber}</td>
                <td>{gg.email}</td>
                <td>{_.map(gg.clientReportMaps, (xx) =>{ return(<span>{xx.reportName +'--'+ xx.frequencyName}<br/></span>) }) }</td>
                </tr>)
                }) :
                <tr>
                <th className="widthSpecific">{xot.inventoryCenterName}</th>
                <th className="widthSpecific">{_.map(xot.processes, (tt) =>{
                  return(<span>{tt.inventoryProcessName}<br/></span>) }) }</th>
                <th className="widthSpecific">{!_.isNull(xot.logo) ? <img src={xot.logo} width='50px' height='30px' alt='clientlogo'/> : null}
                  {!_.isNull(xot.logoName) ? xot.logoName : null }</th><td></td><td></td><td></td><td></td></tr>
                }                          
                </tbody>
              </Table>)
            }) 
          }
        </Row>)
      })
      } 
      </Col>
      </Row>
      </div>
      </Modal.Body>      
      </Modal>
      )
    }
    
 
}

  